<!-- eslint-disable -->
<template>
  <div class="ma-4">
    <ClientNav />
    <div class="ma-2 mt-10">
      <FormDialog
        ref="form-dialog"
        @save-item="save"
        @update-item="update"
        :row="selectedRowNo"
        :isAuditorRole="isAuditorRole"
      />
      <div class="ma-1">
        <v-alert
          dense
          border="top"
          colored-border
          type="info"
          color="primary"
          elevation="2"
        >
          <span class="bm-info">
            <v-row align="center" no-gutters>
              <strong>Fluid Tracking</strong> <br />
              <v-spacer></v-spacer>
              <v-col class="shrink">
                <v-btn
                  color="primary"
                  outlined
                  x-small
                  @click="showInfo1 = !showInfo1"
                >
                  {{ showInfo1 ? "hide" : "show" }}
                </v-btn>
              </v-col>
            </v-row>
            <v-expand-transition>
              <div v-if="showInfo1" class="text-body-2">
                <div>
                  The Individual should have at least 8 Cups of Water daily
                  (aside from other fluids).
                </div>
                <div>
                  Staff record measurements in Cups (1 Cup = 8 fl oz) and sign
                  their initials in each box.
                </div>
                <div class="d-flex ml-3">
                  <div class="mr-3">
                    <ul>
                      <li>W = Water</li>
                      <li>M = Milk</li>
                      <li>J = Juice</li>
                      <li>S = Soda</li>
                    </ul>
                  </div>
                  <div>
                    <ul>
                      <li>H = Home</li>
                      <li>E = Employment/School</li>
                    </ul>
                  </div>
                </div>
                <div class="mt-3">
                  Example: <br />
                  <div class="ml-3">
                    2WH = 2 Cups of Water at Home <br />
                    2WE = 2 Cups of Water at Work
                  </div>
                </div>
              </div>
            </v-expand-transition>
          </span>
        </v-alert>
      </div>

      <v-card class="pa-0 mb-3" outlined flat>
        <v-card-actions>
          <v-btn-toggle>
            <v-btn @click="togglePage('list')">
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-btn>
            <v-btn @click="togglePage('chart')">
              <v-icon>mdi-card-text-outline</v-icon>
            </v-btn>
          </v-btn-toggle>
          <v-spacer></v-spacer>
          <v-btn
            small
            color="success"
            dark
            :loading="isDownloading"
            :disable="isDownloading"
            @click="generateReport"
          >
            download report
            <template v-slot:loader>
              <span>generating...</span>
            </template>
          </v-btn>
        </v-card-actions>
      </v-card>

      <div class="tscroll" v-if="page === 'chart'">
        <v-container v-if="overlay" style="height: 400px">
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="text-subtitle-1 text-center" cols="12">
              Loading chart data...
            </v-col>
            <v-col cols="6">
              <v-progress-linear
                color="indigo"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </v-col>
          </v-row>
        </v-container>

        <div v-if="!overlay">
          <table>
            <thead class="table-head">
              <tr>
                <th class="table-head-th"></th>
                <th
                  class="table-head-th"
                  v-for="(date, i) in chart.dates"
                  :key="i"
                >
                  {{ i + 1 }}
                </th>
              </tr>
            </thead>
            <tbody class="main-body">
              <tr v-for="(row, rowIndex) in chart.items" :key="rowIndex">
                <td
                  v-if="rowIndex % (row.rowspan || 1) === 0"
                  class="main-body--schedule"
                  :rowspan="row.rowspan || 1"
                >
                  <div class="main-body-td--content-schedule text-center">
                    {{ row.scheduled }}
                  </div>
                </td>

                <td
                  v-for="(cell, i) in row.charts"
                  :key="cell.date + i"
                  class="main-body--info"
                  :class="{
                    'blue-bg': row.rowspan === 2 && rowIndex % 2 === 1,
                  }"
                  :bgcolor="
                    userId === cell.records.staffId
                      ? 'green'
                      : userId !== cell.records.staffId &&
                        cell.records.hasRecord === ''
                      ? ''
                      : 'gray'
                  "
                  @click="selectCell(row, cell)"
                >
                  <div class="main-body-td--content text-center">
                    <div v-if="cell.records.hasRecord === false">
                      <span>
                        <v-icon class="white--text">mdi-slash-forward</v-icon>
                        <br />
                        <span class="text-caption white--text">{{
                          cell.records.staff
                        }}</span>
                      </span>
                    </div>

                    <div v-else>
                      <div
                        v-for="(fluid, i) in cell.records.fluidIntakes"
                        :key="i"
                        class="mb-n1 text-caption white--text"
                      >
                        {{ fluid.cup }}{{ fluid.fluid }}{{ fluid.location }}
                      </div>
                      <span class="text-caption white--text">
                        {{
                          cell.records.row === row.row ? cell.records.staff : ""
                        }}
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-else>
        <ChartList />
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable */
import FormDialog from "../chart/FormDialog.vue";
import ClientNav from "@/components/ClientNav";
import ChartList from "./ChartList.vue";
import { mapActions, mapGetters } from "vuex";
import download from "downloadjs";

export default {
  components: {
    ClientNav,
    ChartList,
    FormDialog,
  },
  data() {
    return {
      selectedCell: null,
      dialog: true,
      newValue: "",
      // charts: [],
      scheduledTime: [
        { time: "AM", rowspan: 2 },
        { time: "Noon", rowspan: 2 },
        { time: "PM", rowspan: 1 },
      ],
      // dates: [],
      clientId: "",
      isLoading: false,
      scheduled: "",
      scheduledDate: "",
      FTData: [],
      ftChartId: "",
      showInfo1: true,
      showInfo2: true,
      userId: "",
      scheduleInitials: {
        "Early AM": "em",
        AM: "a",
        Noon: "n",
        PM: "p",
        "Early PM": "ep",
        "Late PM": "lp",
      },
      page: "chart",
      selectedRowNo: null,
      totalFluidIntakes: [],
      isDownloading: false,
      overlay: false,
    };
  },

  computed: {
    ...mapGetters("fluidTrackingCharts", ["chart"]),

    showFTInfo() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.showInfo1 = false;
        this.showInfo2 = false;
      } else {
        this.showInfo1 = true;
        this.showInfo2 = true;
      }
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
     }
  },

  watch: {
    showFTInfo(val) {
      return val;
    },
    async page(newPage) {
      if (newPage === "chart") {
        this.overlay = true;
        await this.fetch();
        this.overlay = false;
      }
    },
  },

  created() {
    this.fetch();
    this.userId = localStorage.getItem("userID");

    if (this.$route.query.ftId === undefined) {
      this.$router.back();
    }
  },
  methods: {
    ...mapActions({
      createItem: "fluidTrackingCharts/createItem",
      updateItem: "fluidTrackingCharts/updateItem",
      downloadItem: "fluidTrackingCharts/downloadItem",
      getChartItems: "fluidTrackingCharts/getChartItems",
      getFT: "fluidTracking/getItemById",
    }),

    selectCell(row, cell) {
      this.selectedRowNo = row.row;
      this.selectedCell = cell;
      this.scheduled = row.scheduled;
      this.scheduledDate = cell.date;
      this.ftChartId = cell.records._id;

      if (cell.records.staffId === "") {
        this.$refs["form-dialog"].show();
      }

      if (cell.records.staffId === this.userId) {
        this.$refs["form-dialog"].show();
        this.$refs["form-dialog"].populateData(cell.records);
      }

      if (cell.records.staffId != this.userId) return;
    },

    async fetch() {
      try {
        this.isLoading = true;
        this.clientId = this.$route.params.clientID;
        await this.getChartItems(this.$route.query.ftId);
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },

    async save(data) {
      const req_body = {
        ...data,
        scheduled: this.scheduled,
        scheduledDate: this.scheduledDate,
        clientId: this.clientId,
        ftId: this.$route.query.ftId,
      };
      try {
        await this.createItem(req_body);
        this.fetch();
      } catch (error) {
        console.log(error);
      }
    },

    async update(data) {
      const req_body = {
        ...data,
        scheduled: this.scheduled,
        scheduledDate: this.scheduledDate,
        clientId: this.clientId,
        ftId: this.$route.query.ftId,
      };
      try {
        await this.updateItem({ data: req_body, id: this.ftChartId });
        this.fetch();
      } catch (error) {
        console.log(error);
      }
    },

    async generateReport() {
      this.isDownloading = true;
      try {
        const response = await this.downloadItem(this.$route.query.ftId);
        let pdfFile = "data:application/octet-stream;base64," + response;
        let fileName = `fluid-chart.pdf-${Date.now()}.pdf`;
        download(pdfFile, fileName, "application/pdf");
        this.isDownloading = false;
      } catch (e) {
        console.log(e);
        this.isDownloading = false;
      }
    },

    togglePage(page) {
      this.page = page;
    },
  },
};
</script>

<style scoped>
.tscroll {
  overflow-x: auto;
  margin-bottom: 10px;
}

/* .tscroll table td:nth-child(1){
  left: 0;
  position: sticky;
} */

/* .tscroll table,
thead,
tr,
th:first-child {
  position: sticky;
  left: 0;
}  */

.tscroll td,
.tscroll th {
  border-bottom: 1px dashed black;
  border-right: 1px dashed black;
}

.main-body {
  background-color: rgb(255, 255, 255);
}

.main-body--schedule {
  background-color: rgb(230, 228, 226);
}

.main-body-td--content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 7vh;
  min-width: 7vh;
}

.main-body-td--content-schedule {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 8vh;
  min-width: 8vh;
}

.table-head-th {
  border-top: 1px dashed black;
  background-color: rgb(230, 228, 226);
}

.main-body--info {
  transition: 0.3s;
}

.main-body--info:hover {
  background-color: gray;
  cursor: pointer;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
</style>
